enum BiteLogMaitredEvent {
  OK = 0,
  OrderValidateError = 1,
  OrderSendToPosError = 2,
  OrderCourierValidateError = 3,
  OrderSendToLoyaltyError = 4,
  OrderSendToI9nsError = 5,
  OrderValidated = 11,
  OrderValidationSkipped = 12,
  OrderValidationSuperseded = 13,
  OrderValidationSkippedUnchanged = 14,
  OrderReceived = 21,
  OrderSentToPos = 23,
  OrderSentToLoyalty = 24,
  LateOrderReceived = 25,
  OrderSentToI9ns = 26,
  ScreenshotReceived = 36,
  DeviceLogsReceived = 37,
  OrderSendingSkipped = 46,
  OrderSendToLoyaltySkipped = 47,
  OrderVoidedOnLoyalty = 48,
  OrderVoidOnLoyaltyError = 49,
  OrderVoidOnLoyaltySkipped = 50,
  WebhookReceived = 53,
  TransactionCommitted = 54,
  TransactionCommitError = 55,
  TransactionRefundIssued = 56,
  TransactionRefundError = 57,
  Webhook86dItemsFailed = 58,
  Webhook86dItemsSuccessful = 59,
  WebhookMenuUpdateFailed = 60,
  WebhookMenuUpdateSuccessful = 61,
  OrderValidatedOnLoyalty = 62,
  OrderValidationOnLoyaltySkipped = 63,
  OrderValidationOnLoyaltyError = 64,
  OrderValidatedOnOther = 65,
  OrderValidationOnOtherSkipped = 66,
  OrderValidationOnOtherError = 67,
  OrderPatchOnQsr = 71,
  OrderPatchOnQsrError = 72,
  GuestReceiptEmailError = 81,
  GuestReceiptEmail = 82,

  GuestReceiptSmsError = 85,
  GuestReceiptSms = 86,

  NotifierSendError = 91,
  LoyaltySignupSmsError = 92,
  LoyaltySignupSms = 93,
  NotificationAddToQueue = 94,
  NotificationAddToQueueError = 95,
  LoyaltySignupInstantEnrollError = 96,
  LoyaltySignupInstantEnroll = 97,

  OrderCreated = 101,
  OrderCreatedError = 102,
  IdempotentOrderCreated = 103,
  IdempotentOrderReceived = 104,
  OrderCreatedOnLoyalty = 105,
  OrderCreatedOnLoyaltyError = 106,
  OrderCreatedOnLoyaltySkipped = 107,

  OrderValidateTip = 111,
  OrderValidateTipError = 112,

  OrderValidateDonation = 113,
  OrderValidateDonationError = 114,

  OrderUpdated = 121,
  OrderUpdatedError = 122,
  FreeItemPromotionApplied = 123,

  OrderCloned = 126,
  OrderClonedError = 127,

  OrderClosed = 131,
  OrderClosedError = 132,
  IdempotentOrderClosed = 133,

  OrderCancelled = 151,
  OrderCancelledError = 152,
  IdempotentOrderCancelled = 153,

  OrderRefunded = 161,
  OrderRefundError = 162,
  IdempotentOrderRefunded = 163,

  OrderAbandoned = 171,
  OrderAbandonError = 172,

  OrderAddToSendOrderQueue = 201,
  OrderAddToSendOrderQueueError = 202,
  OrderGetSendOrderQueueError = 203,

  OrderWaitTimeSendOrderQueue = 204,

  OrderPosSendAttemptDuration = 205,
  OrderClientSendDuration = 206,

  OrderAddToValidateOrderQueue = 207,
  OrderAddToValidateOrderQueueError = 208,
  OrderGetValidateOrderQueueError = 209,

  OrderWaitTimeValidateOrderQueue = 210,

  OrderAddToCreateOrderQueue = 221,
  OrderAddToCreateOrderQueueError = 222,
  OrderGetCreateOrderQueueError = 223,

  OrderWaitTimeCreateOrderQueue = 224,

  OrderCreatedOnPos = 225,
  OrderCreatedOnPosError = 226,
  OrderCreatedOnPosSkipped = 227,

  OrderAddToUpdateOrderOnPosQueue = 231,
  OrderAddToUpdateOrderOnPosQueueError = 232,
  OrderGetUpdateOrderOnPosQueueError = 233,

  OrderWaitTimeUpdateOrderOnPosOrderQueue = 234,

  OrderUpdatedOnPos = 235,
  OrderUpdateOnPosError = 236,
  OrderUpdateOnPosSkipped = 237,

  PaymentFlashCreate = 301,
  PaymentFlashCreateError = 302,
  PaymentFlashCreateIdempotent = 303,
  PaymentKioskCreate = 311,
  PaymentKioskCreateError = 312,
  PaymentKioskCreateIdempotent = 313,
  PaymentStoredValueCreate = 321,
  PaymentStoredValueCreateError = 322,
  PaymentStoredValueCreateIdempotent = 323,
  PaymentStoredValueInquire = 324,
  PaymentStoredValueInquireError = 325,
  PaymentGetStoredValueCreateQueueError = 326,
  PaymentStoredValueBalanceLookup = 327,
  PaymentStoredValueBalanceLookupError = 328,
  PaymentStoredValueGetTenders = 329,
  PaymentStoredValueGetTendersError = 330,
  PaymentRefund = 331,
  PaymentRefundError = 332,
  PaymentRefundIdempotent = 333,
  PaymentGetRefundQueueError = 334,
  PaymentAddToRefundQueue = 335,
  PaymentRefundAddToRefundQueueError = 336,
  PaymentGetEcommQueueError = 337,
  PaymentAddToEcommQueue = 338,
  PaymentAddToEcommQueueError = 339,
  PaymentGetKioskApiQueueError = 350,
  PaymentAddToKioskApiQueue = 351,
  PaymentAddToKioskApiQueueError = 352,
  PaymentKioskApiCreate = 353,
  PaymentKioskApiCreateError = 354,
  PaymentKioskApiCreateIdempotent = 355,
  PaymentKioskApiCancel = 356,
  PaymentKioskApiCancelError = 357,
  PaymentStripeDisbursementError = 358,
  PaymentStripeDisbursementAddToQueue = 359,
  PaymentStripeDisbursementAddToQueueError = 360,
  PaymentStripeDisbursementReversalError = 361,
  PaymentStripeDisbursementReversalAddToQueue = 362,
  PaymentStripeDisbursementReversalAddToQueueError = 363,

  PaymentWaitTimeKioskApiPaymentQueue = 364,

  PaymentKioskApiRecovery = 365,
  PaymentKioskApiRecoveryError = 366,

  PaymentKioskPreReadCardQueue = 367,
  PaymentKioskPreReadCardQueueError = 368,
  PaymentKioskPreReadCard = 369,
  PaymentKioskPreReadCardError = 340,

  PaymentNativeResponseCorrection = 381,
  PaymentNativeResponseException = 382,
  PaymentNativeRefundRequested = 385,

  OrderCouponAdd = 401,
  OrderCouponAddError = 402,

  OrderCouponRemove = 501,
  OrderCouponRemoveError = 502,

  OrderCompCardApply = 551,
  OrderCompCardApplyError = 552,
  OrderCompCardRemove = 553,
  OrderCompCardRemoveError = 554,
  OrderSentToCompCard = 561,
  OrderSendToCompCardError = 562,
  OrderSendToCompCardSkipped = 563,
  OrderVoidedOnCompCard = 564,
  OrderVoidOnCompCardError = 565,
  OrderVoidOnCompCardSkipped = 566,

  OrderLoyaltyAddReward = 601,
  OrderLoyaltyAddRewardError = 602,

  OrderLoyaltyAddUnappliedReward = 603,
  OrderLoyaltyAddUnappliedRewardError = 604,

  OrderLoyaltyGetAvailableRewards = 701,
  OrderLoyaltyGetAvailableRewardsError = 702,
  OrderLoyaltyGetAvailableRewardsNoOrder = 703,
  OrderLoyaltyGetAvailableRewardsNoOrderError = 704,

  OrderLoyaltyRemoveReward = 801,
  OrderLoyaltyRemoveRewardError = 802,
  OrderLoyaltyIdempotentRemoveReward = 803,

  OrderLoyaltyRedeemRewardCode = 850,
  OrderLoyaltyRedeemRewardCodeError = 851,

  OrderLoyaltyAuth = 901,
  OrderLoyaltyAuthError = 902,
  OrderLoyaltySignOut = 911,
  OrderLoyaltySignOutError = 912,

  OrderFetchGuestHistory = 950,
  OrderFetchGuestHistoryError = 951,
  OrderFetchGuestHistoryMatchingError = 952,
  OrderFetchGuestHistoryNoGuestFound = 953,
  OrderFetchGuestHistoryLoyalty = 954,
  OrderFetchGuestHistoryLoyaltyError = 955,

  MenuFetch = 1001,
  MenuFetchError = 1002,

  MenuSyncWaitTimeQuicksandQueue = 1003,
  MenuSyncDuration = 1004,
  MenuSyncDurationAndWaitTime = 1005,
  MenuSyncError = 1006,

  QueueJobCompleted = 1100,
  QueueJobStalled = 1101,
  QueueJobFailed = 1102,
  QueueWaitingCountOk = 1103,
  QueueWaitingCountError = 1104,
  QueueJobRequeued = 1105,

  ReportSend = 1200,
  ReportSendError = 1201,

  WebhookSend = 1300,
  WebhookSendError = 1301,

  SmsNotifierSend = 1400,
  SmsNotifierSendError = 1401,
  SmsNotifierSendErrorLight = 1402,

  ExpoPrintAuthError = 1600,

  FulfillmentPayloadFetchSuccess = 1700,
  FulfillmentPayloadFetchError = 1701,
  FulfillmentPayloadSendAttemptSuccess = 1702,
  FulfillmentPayloadSendAttemptError = 1703,
  OrderSendToFulfillmentError = 1710,
  OrderSendToFulfillmentSkipped = 1711,
  OrderSentToFulfillment = 1712,

  OrderSentToMarketing = 1800,
  OrderSendToMarketingError = 1801,
  OrderSendToMarketingSkipped = 1802,
  OrderRedirectedToSurvey = 1803,
  OrderRedirectToSurveyError = 1804,

  KioskPaymentTerminalStatusCheck = 1500,
  KioskPaymentTerminalStatusCheckError = 1501,
  KioskPaymentTerminalStoppedDuringPayment = 1502,
  KioskPaymentTerminalStoppedDuringPaymentError = 1503,
  KioskPaymentTerminalWakeUp = 1504,
  KioskPaymentTerminalWakeUpError = 1505,
  KioskPaymentTerminalModelCheckError = 1506,

  MenuCacheGetMenuComponentsError = 1900,
  MenuCachePutMenuComponentsError = 1910,
  MenuCachePutMenuTimestampError = 1911,
  MenuCachePutMenuLastUpdatedTimestampError = 1912,
  MenuCacheAssembleAndStoreMenuComponentsError = 1920,
  MenuCacheAssembleAndStoreMenuComponents = 1921,
  MenuCacheJobBuildError = 1930,
  MenuCacheJobAssembleAndStoreMenuComponentsError = 1931,
  MenuCacheJobGetMenuLastUpdatedTimestampError = 1932,
  MenuCacheJobCacheOutdatedError = 1933,
  MenuCacheJobLocationNotFoundError = 1934,
  MenuCacheJobLocationCannotUseCacheWarning = 1935,
  MenuCacheGzipCompressDuration = 1936,
  MenuCacheGzipDecompressDuration = 1937,

  WebhookThirdPartyOrderAccepted = 2000,
  WebhookThirdPartyOrderRejected = 2001,
  ThirdPartyOrderSendError = 2010,
  ThirdPartyOrderWaitTimeSendOrderQueue = 2011,
  ThirdPartyOrderSendAttemptDuration = 2012,
  ThirdPartyOrderSendToFulfillmentError = 2013,
  ThirdPartyOrderSendToFulfillmentSkipped = 2014,
  ThirdPartyOrderSentToFulfillment = 2015,

  GuestMerge = 2100,

  ValidateIntegrationCredentialsError = 2200,

  KorAlertSubscribed = 2301,
  KorAlertUnsubscribed = 2302,

  OfflineModeOrderProcessedByBackendSuccess = 2400,
  OfflineModeOrderProcessedByBackendError = 2401,
}

export { BiteLogMaitredEvent };
